import React, { useEffect } from "react"

import background from "~/assets/images/bg-modal.jpg"

import { Button } from "~/components"
import { Container, Dialog, Close, Body, Figure, Content } from "./styles"

export default function Modal({ open, close }) {
  useEffect(() => {
    if (open) {
      document.querySelector("body").style.overflowY = "hidden"
      document.querySelector("body").style.paddingRight = "16px"
      return
    }
    document.querySelector("body").style.overflowY = "auto"
    document.querySelector("body").style.paddingRight = "0"
  }, [open])

  if (!open) return null

  return (
    <Container>
      <Dialog>
        <Close
          onClick={() => {
            const dataLayer = window.dataLayer || []

            dataLayer.push({
              event: "fechar_modal",
              nome: "chat-porto-seguro-faz",
            })

            close()
          }}
        />
        <Body>
          <Figure>
            <img src={background} alt="background" />
          </Figure>
          <Content>
            <h1>Olá, tudo bem?</h1>
            <p>
              Para solicitar os serviços disponíveis no seu plano SOS Auto,
              entre em contato conosco através do chat da Porto Seguro Faz
            </p>
            <center>
              <Button
                data-gtm-type="click"
                data-gtm-clicktype="button"
                data-gtm-name="chat da porto seguro faz"
                onClick={() => {
                  window.open(
                    "https://prime.altubots.com/chats/portoassistencia/7977097ff8398ca523d5ff4213473079/index.html"
                  )
                }}
              >
                Chat da Porto Seguro Faz
              </Button>
            </center>
            <p>
              Se preferir, entre em contato através da Central de Atendimento
              24h através dos telefones 3003-3951(capitais e regiões
              metropolitanas) ou 0800-703-3451 (demais localidades)
            </p>
          </Content>
        </Body>
      </Dialog>
    </Container>
  )
}
